package com.crowpay.extensions

import com.crowpay.LineItem
import com.crowpay.ScopeView
import com.crowpay.Specification
import com.lightningkite.UUID

fun List<Specification>.toLineItems(project: UUID): Map<ScopeView?, List<LineItem>> =
    groupBy { it.group }
        .entries
        .associate { (view, specs) ->
            val scope = view?.toScopeView(project)
            scope to specs.map { it.toLineItem(project, scope) }
        }